import r from "./restArguments.js";
import t from "./uniq.js";
import o from "./_flatten.js";
var n = r(function (r) {
  return t(o(r, !0, !0));
});
export { n as default };